export default "/_next/static/assets/spaceport-logo-main_5ef0dff59322bf928e7e1a0ee4ce4043.webp";